import { formatRTRConnectionResource } from "areas/verifications/helpers/rtr";
import { Tag } from "ui-kit/icon";
import { IIngestionSourceData } from './types';

const manualCsv: IIngestionSourceData = {
  displayName: "Rent The Runway",
  isEcom: false,
  isAutomated: false,
  parsedDataFormatter: formatRTRConnectionResource,
  listInventory: {
    linkHref: "/addListing",
    icon: Tag
  }
}

export default manualCsv